import React from 'react';
import './StatsBand.css';

// Numbers here mirror claims already made elsewhere on the site
// (discovery output, coverage growth, self-healing, hero setup time).
const STATS = [
  { value: '30–40', label: 'tests generated from a single discovery' },
  { value: 'up to 95%', label: 'workflow coverage as you grow' },
  { value: '80%', label: 'less test maintenance with self-healing' },
  { value: '60s', label: 'to create your first test' },
];

const StatsBand = () => {
  return (
    <section className="stats-band" aria-label="Qate AI by the numbers">
      <div className="stats-band-inner">
        {STATS.map((stat) => (
          <div className="stat-block" key={stat.label}>
            <span className="stat-value">{stat.value}</span>
            <span className="stat-caption">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsBand;
